// @flow

import { lighten } from 'polished';

import { Colors } from '@zapier/theme';
import { css } from '@emotion/core';

export const menuCss = () =>
  css({
    cursor: 'pointer',
  });

export const menuItemBaseCss = css({
  display: 'flex',
  alignItems: 'center',
  padding: '10px',
});

export const menuItemHighlightedCss = css({
  backgroundColor: Colors.storm,
});

export const menuItemHighlightedButDisabledCss = css({
  backgroundColor: lighten(0.035, Colors.storm),
});

const menuItemDisabledCss = css({
  color: Colors.steel,
  cursor: 'default',
});

type GetMenuItemCssProps = {
  isDisabled: boolean,
  isHighlighted: boolean,
};

export const getMenuItemCss = ({
  isHighlighted,
  isDisabled,
}: GetMenuItemCssProps) => {
  const menuItemCss = css(
    menuItemBaseCss,
    !isDisabled && isHighlighted && menuItemHighlightedCss,
    isDisabled && isHighlighted && menuItemHighlightedButDisabledCss,
    isDisabled && menuItemDisabledCss
  );

  return menuItemCss;
};

export const menuItemTextCss = css({
  flex: 1,
  margin: '0 12px',
  lineHeight: '1.3',
});
